
 /**
 * Event `Search.SearchResult`
 *
 * @typedef {Object} MultSceneForApp~Search~Events~SearchResult
 * @property {string} type - type of event, has value `search.searchresult`
 * @property {String} id - ID of layer
 * @property {Boolean} visibility - visibility of layer
 */

export default function createEventSearchResult(result) {
    return {
        type: 'search.searchresult',
        result: result
    };
}
